import React from 'react';
import Kit from "./assets/i/items/medKit.png";
import vechyvanka from "./assets/i/items/vechyvanka.png";
import shield from './assets/i/items/shield.png';
import vechyvanka2 from "./assets/i/items/vechyvanka2.png";
import bortch from "./assets/i/items/bortch.png";
import invisible from "./assets/i/items/invisibleSphere.png";
import invincible from "./assets/i/items/invincibleSphere.png";
import zalujni from "./assets/i/items/ZaluzniSphere.png";
import { useTranslation } from 'react-i18next';


const ListItems = () => {
    const { t } = useTranslation();

    return (
        <dl>
            <div className="row">
                <dt>
                    <img alt={t("Shield")} src={shield} />
                </dt>
                <dd>
                    <h3>{t("shield")}</h3>
                    <p>{t("boost your protection of 1%.")}</p>
                </dd>
            </div>
            <div className="row">
                <dt>
                    <img alt={t("Green Vyshyvanka")} src={vechyvanka} />
                </dt>
                <dd>
                    <h3>{t("Green Vyshyvanka")}</h3>
                    <p><a href="https://en.wikipedia.org/wiki/Vyshyvanka">{t("This Vyshyvanka")}</a> {t("improve your protection to 100%.")}</p>
                </dd>
            </div>
            <div className="row">
                <dt>
                    <img alt={t("Red vyshyvanka")} src={vechyvanka2} />
                </dt>
                <dd>
                    <h3>{t("Red vyshyvanka")}</h3>
                    <p>{t("The same as the green one")}</p>
                </dd>
            </div>
            <div className="row">
                <dt>
                    <img alt={t("Bortch")} src={bortch} />
                </dt>
                <dd>
                    <h3>{t("Bortch")}</h3>
                    <p>{t("Picking a bortch")}</p>
                </dd>
            </div>
            <div className="row">
                <dt>
                    <img alt={t("Medial kit")} src={Kit} />
                </dt>
                <dd>
                    <h3>{t("Medial kit")}</h3>
                    <p>{t("The black medical kit give extra punch!")}</p>
                </dd>
            </div>
            <div className="row">
                <dt>
                    <img alt={t('Invisibility sphere')} src={invisible} />
                </dt>
                <dd>
                    <h3>{t('Invisibility sphere')}</h3>
                    <p>{t('This yellow and blue sphere')}</p>
                </dd>
            </div>
            <div className="row">
                <dt>
                    <img alt={t('Invicibility sphere')} src={invincible} />
                </dt>
                <dd>
                    <h3>{t('Invicibility sphere')}</h3>
                    <p>{t('The sphere of invincibility')}</p>
                </dd>
            </div>
            <div className="row">
                <dt>
                    <img alt={t('Zaloujny Sphere')} src={zalujni} />
                </dt>
                <dd>
                    <h3>{t('Zaloujny Sphere')}</h3>
                    <p>{t('The Zaloujny sphere give you 200 life points!')} </p>
                </dd>
            </div>
        </dl>
    );
}

export default ListItems;

